import { Grid, LinearProgress } from "@mui/material";
import PropTypes from "prop-types";
import { Fragment } from "react";
import React from "react";

import Logo from "../images/logo.svg";

export const Loading = ({ top = false, logo = true }) => {
  return (
    <Fragment>
      <Grid
        alignItems="center"
        container
        direction="column"
        justifyContent="center"
        spacing={0}
        style={top ? {} : { minHeight: "100vh" }}
      >
        <Grid item>
          {logo && <Logo />}
          <LinearProgress />
        </Grid>
      </Grid>
    </Fragment>
  );
};

Loading.propTypes = {
  top: PropTypes.bool,
  logo: PropTypes.bool,
};
